<template>
  <div v-if="files.length > 0" class="PeriodFileList">
    <div
      class="file"
      v-for="item in files"
      :key="item.datum_id"
      :id="`datum-${item.datum_id}`"
      @click="onPreview(item)"
    >
      <div class="left">
        <div class="icon" :class="{ [getFileTypeName(item.docType)]: true }"></div>
        <span class="name">
          {{ item.name }}
        </span>
        <span v-if="item.is_last_time_viewed === 1" class="last-viewed"> 上次学到 </span>
        <span v-else-if="item.is_viewed === 1" class="viewed"> 已学 </span>
        <span v-else class="unviewed"> 未学 </span>
      </div>
      <div class="right">
        <i class="el-icon-arrow-right" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PeriodFileList',

  props: {
    period: {
      type: Object,
      default: () => {},
    },
    //检测附件所在课程是否可查看（限制访问、过期、冻结等）
    checkAvailableFunction: {
      type: Function,
      default: () => true,
    },
    isViewedReport: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    files() {
      if (this.period?.datum?.length > 0) {
        return this.period.datum.map((item) => ({
          datum_id: item.datum_id,
          name: item.file_name,
          docType: item.doc_type, //doc_type 字段用于标识资料或点播课文件类型： 0 默认类型，1 视频类型 2音频类型 3 word 4 ppt 5 pdf 6 图片
          fid: item.fid.split(';'),
          course_basis_id: item.course_basis_id,
          course_chapter_id: item.course_chapter_id,
          is_viewed: item.is_viewed,
          is_last_time_viewed: item.is_last_time_viewed,
        }));
      }
      return [];
    },
  },

  methods: {
    getFileTypeName(docType) {
      switch (docType) {
        case 1:
          return 'video';
        case 2:
          return 'audio';
        case 3:
          return 'word';
        case 4:
          return 'ppt';
        case 5:
          return 'pdf';
        case 6:
          return 'image';
        default:
          return 'unknown';
      }
    },
    async onPreview(file) {
      if (await this.checkAvailableFunction()) {
        if (this.isViewedReport) {
          await this.$http.post('/api/app/myStudy/report', {
            type: 1,
            course_basis_id: file.course_basis_id,
            course_chapter_id: file.course_chapter_id,
            datum_id: file.datum_id,
          });
        }

        this.$webSeeSendTrack({
          event_id: 'my_courses_picture_class_click',
          event_type: 'click',
          data: {
            period_id: this.period.periods_id,
            period_title: this.period.periods_title,
            period_type: this.period.periods_type,
            name: file.name,
          },
        });

        // 视频或音频
        if ([1, 2].includes(file.docType)) {
          let data = await this.$http.get('/api/app/user/CourseWare/video/preview', {
            video_id: file.fid,
          });
          // window.open(data[0].url);
          this.open(data[0].url);
        } else {
          let data = await this.$http.get('/api/app/user/CourseWare/preview', {
            fid: file.fid,
          });
          // window.open(data);
          this.open(data);
        }
      }
    },
    async onPreviewFirstFile() {
      this.onPreview(this.files[0]);
    },
    open(url) {
      let hasOrigin = false;
      try {
        const urlObj = new URL(url);
        // 如果 URL 对象成功创建，并且 origin 属性存在
        hasOrigin = !!urlObj.origin;
      } catch (e) {
        // 如果 URL 对象创建失败（例如，urlString 不是一个有效的 URL），则返回 false
        hasOrigin = false;
      }
      url = hasOrigin ? url : `${location.origin}${url}`;

      //桌面端内
      if (this.$store.state.desktop) {
        // 支持安全锁的版本
        if (this.$store.state.desktop.deviceInfo) {
          this.$router.push({
            name: 'Iframe',
            query: {
              url: this.ensureHttps(url),
            },
          });
        } else {
          this.$store.state.desktop.openurl(this.ensureHttps(url)); // 不支持安全锁的版本
        }
      } else {
        //桌面端外
        window.open(url);
      }
    },
    ensureHttps(url) {
      // 使用 URL 对象解析输入的 URL
      const parsedUrl = new URL(url);

      // 检查协议是否为 'https:'
      if (parsedUrl.protocol !== 'https:') {
        // 如果不是 'https:'，则修改为 'https:'
        parsedUrl.protocol = 'https:';
      }

      // 返回修改后的 URL 字符串
      return parsedUrl.toString();
    },
  },
};
</script>
<style lang="scss" scoped>
.PeriodFileList {
  display: flex;
  flex-direction: column;
  gap: 16px;
  .file {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    &:hover {
      .name {
        color: $primary-color !important;
      }
    }
    .left {
      display: flex;
      align-items: center;
      gap: 8px;
      .icon {
        display: inline-block;
        width: 24px;
        height: 24px;
        background-size: 100% 100%;
        flex-shrink: 0;
        &.unknown {
          background-image: url('~@/assets/images/common/icons/flies/unknown.svg');
        }
        &.video {
          background-image: url('~@/assets/images/common/icons/flies/video.svg');
        }
        &.audio {
          background-image: url('~@/assets/images/common/icons/flies/audio.svg');
        }
        &.word {
          background-image: url('~@/assets/images/common/icons/flies/word.svg');
        }
        &.ppt {
          background-image: url('~@/assets/images/common/icons/flies/ppt.svg');
        }
        &.pdf {
          background-image: url('~@/assets/images/common/icons/flies/pdf.svg');
        }
        &.image {
          background-image: url('~@/assets/images/common/icons/flies/image.svg');
        }
      }
      .name {
        flex: 1;
        cursor: pointer;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Regular;
        color: #1e1c22;
        line-height: 22px;
        word-wrap: break-word;
      }
      .last-viewed,
      .viewed,
      .unviewed {
        display: inline-block;
        padding: 2px 4px;
        border-radius: 4px;
        margin-left: 8px;
        font-size: 12px;
        line-height: 17px;
        background: #f0f3fc;
      }
      .last-viewed {
        font-size: 10px;
        line-height: 14px;
        color: #f55;
        background: #ffefec;
      }
      .viewed {
        color: #a6a6b1;
      }
      .unviewed {
        color: #46454e;
      }
    }
  }
}
</style>
